// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2837":"65c0a753","9558":"93c92401"}[chunkId] + ".chunk.css";
};